export interface FacilityDocument {
  id: string;
  facilityId: string;
  documentType: FacilityDocumentType;
  documentTypeDisplay: string;
  fileName: string;
  isVerified: boolean;
  expirationDate: string;
  uploadedAt: string;
  isExpired: boolean;
  isExpiringSoon: boolean;
  previewUrl: string;
}

export interface UploadFacilityDocument {
  documentType: FacilityDocumentType;
  fileName: string;
  filePath?: string;
  fileContent: string;
  fileSizeBytes?: number;
  mimeType?: string;
  expirationDate?: string;
  uploadBy?: string;
}

export enum FacilityDocumentType {
  BUSINESS_LICENSE = 'BusinessLicense',
  INSURANCE_CERTIFICATE = 'InsuranceCertificate',
  TAX_EXEMPT_CERTIFICATE = 'TaxExemptCertificate',
  ACCREDITATION_CERTIFICATE = 'AccreditationCertificate',
  CONTRACT_AGREEMENT = 'ContractAgreement',
  OTHER_CERTIFICATION = 'Other',
  W9_FORM = 'W9Form'
}
